import * as React from 'react';
import { DestinationRefinementContainer } from './destination-refinement-container';
import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { PwaHsrPropertyDestinationRefinement } from 'src/common/__generated__/api';
import { AnalyticsStore } from 'bernie-core';

export interface DestinationRefinementVariantProps {
  title: string;
  destinations: PwaHsrPropertyDestinationRefinement.Destinations[];
  isCarousel: boolean;
  analytics?: AnalyticsStore;
}

export const DestinationRefinementVariants: React.FunctionComponent<DestinationRefinementVariantProps> = ({
  title,
  destinations,
  isCarousel,
  analytics
}) => (
  <AbacusExperiment name="PWA_Display_Destination_Refinement_Module">
    <AbacusControl />
    <AbacusVariant bucket={1}>
      <DestinationRefinementContainer {...{ isCarousel, title, destinations, analytics }} />
    </AbacusVariant>
    <AbacusVariant bucket={2}>
      <DestinationRefinementContainer showAffinities={true} {...{ isCarousel, title, destinations, analytics }} />
    </AbacusVariant>
    <AbacusVariant bucket={3}>
      <DestinationRefinementContainer showDescription={true} {...{ isCarousel, title, destinations, analytics }} />
    </AbacusVariant>
  </AbacusExperiment>
);
